import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e12db850&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e12db850&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=e12db850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12db850",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WxFollowQr: require('/drone/src/components/WxFollowQr.vue').default,SvgIcon: require('/drone/src/components/SvgIcon/index.vue').default,NewUserCoupon: require('/drone/src/components/NewUserCoupon/index.vue').default,LoginTemplate: require('/drone/src/components/LoginTemplate/index.vue').default})
